import { defineMessages } from 'react-intl';

const messages = defineMessages({
  payableAmountTooltip: {
    id: 'sku-shared.payout-amount-tooltip',
    defaultMessage: 'Payouts are inclusive of any applicable tax, unless ClassPass communicates otherwise.',
  },
  orderCancelled: {
    id: 'sku-orders.dashboard.order-cancelled',
    defaultMessage: 'Order cancelled',
  },
  fulfilled: {
    id: 'sku-orders.dashboard.fulfilled',
    defaultMessage: 'Fulfilled',
  },
  emailModalTitle: {
    id: 'sku-orders.dashboard.email-modal-title',
    defaultMessage: 'Email customer',
  },
  emailModalSubject: {
    id: 'sku-orders.dashboard.email-modal-subject',
    defaultMessage: 'Update regarding your {time}, {date} order at {venueName}',
  },
});

export const skuSharedMessages = {
  payableAmountTooltip: messages.payableAmountTooltip,
};

export default messages;
